import type { SVGProps } from "react";
export interface RecycleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function RecycleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: RecycleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M5.436 8.075a1.125 1.125 0 0 1 1.945 1.13l-3.995 6.87c-.719 1.238.172 2.808 1.64 2.809l1.946.001.116.006a1.125 1.125 0 0 1-.002 2.238l-.115.006-1.944-.001c-3.177-.002-5.19-3.43-3.586-6.19l3.995-6.87Zm14.625 4.783a1.125 1.125 0 0 1 1.475.311l.063.097.97 1.673.14.26c1.336 2.712-.65 5.928-3.728 5.928h-7.988a1.126 1.126 0 0 1 0-2.25h7.988c1.47 0 2.362-1.57 1.644-2.809l-.973-1.672-.053-.103a1.126 1.126 0 0 1 .462-1.435M8.414 2.931C10.01.188 13.992.19 15.587 2.935l3.995 6.87.052.102a1.126 1.126 0 0 1-1.936 1.125l-.062-.096-3.994-6.87c-.728-1.253-2.554-1.254-3.283-.002l-.974 1.673A1.125 1.125 0 0 1 7.44 4.605l.973-1.673Z"
      />
      <path
        fill={color}
        d="M12.388 17.115a1.124 1.124 0 0 1 1.469 1.699L12.619 20l1.238 1.189.08.083a1.126 1.126 0 0 1-1.55 1.616l-.087-.076-2.085-1.998a1.126 1.126 0 0 1 0-1.625l2.085-2zM6.21 7.532a1.126 1.126 0 0 1 1.289.833l.7 2.794.022.112a1.125 1.125 0 0 1-2.171.545l-.034-.11-.419-1.666-1.667.476a1.125 1.125 0 1 1-.618-2.164L6.1 7.558l.112-.026Zm12.007-.229a1.126 1.126 0 0 1 2.182.548l-.7 2.794a1.126 1.126 0 0 1-1.4.807l-2.786-.794.309-1.081.307-1.083 1.669.475zM14.74 9.268c.17-.598.793-.944 1.39-.774l-.616 2.164a1.125 1.125 0 0 1-.774-1.39"
      />
    </svg>
  );
}
